import { c as _c } from "react/compiler-runtime";
import Badge from "@/components/ui/badge";
import { getExpiryInfo } from "@/lib/document-expiry";
interface ExpiryBadgeProps {
  expiryDate: string | null | undefined;
  /** Hide the badge for valid (non-expiring) IDs — only warn/error show. */
  onlyWhenNoteworthy?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
}

/**
 * Renders an Expired / Expires-in-N-days / Valid badge for a document's expiry
 * date. Returns null when there's no expiry on file.
 */
export default function ExpiryBadge(t0) {
  const $ = _c(6);
  const {
    expiryDate,
    onlyWhenNoteworthy: t1,
    size: t2
  } = t0;
  const onlyWhenNoteworthy = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "sm" : t2;
  let t3;
  if ($[0] !== expiryDate) {
    t3 = getExpiryInfo(expiryDate);
    $[0] = expiryDate;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const info = t3;
  if (!info) {
    return null;
  }
  if (onlyWhenNoteworthy && info.status === "valid") {
    return null;
  }
  let t4;
  if ($[2] !== info.badgeVariant || $[3] !== info.label || $[4] !== size) {
    t4 = <Badge variant={info.badgeVariant} size={size}>{info.label}</Badge>;
    $[2] = info.badgeVariant;
    $[3] = info.label;
    $[4] = size;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}